import { COLOR_FOCUS_BORDER, COLOR_FOCUS_RING, COLOR_TEXT_MUTED } from './variables';

export const inputFocusStyles = `
  outline: none;
  border-color: ${COLOR_FOCUS_BORDER};
  box-shadow: 0 0 0 3px ${COLOR_FOCUS_RING};
`;

export const uppercaseLabelStyles = `
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${COLOR_TEXT_MUTED};
`;
